import request from '@/utils/request'
import app from '../../main'

export default {
    getLeaders: async({ dispatch, commit }) => {
        await request({ method: 'get', url: 'leaders' })
            .then(res => {
                if (res.data && res.data.leaders) {
                    commit('SET_LEADERS', res.data.leaders)
                }
            })
            .catch(error => {
                if (error.response && error.response.data &&
                    error.response.data.message &&
                    error.response.data.code !== 403) {
                    dispatch('addMessage', {
                        status: 'error',
                        message: error.response.data.message,
                        locale: true
                    }, { root: true })
                }
            })
    },

    getBusinesses: async({ dispatch, commit }, params) => {
        await request({ method: 'get', url: 'businesses', params })
            .then(res => {
                if (res.data && res.data.businesses) {
                    commit('SET_BUSINESSES', res.data.businesses)
                }
            })
            .catch(error => {
                if (error.response && error.response.data && error.response.data.message) {
                    dispatch('addMessage', {
                        status: 'error',
                        message: error.response.data.message,
                        locale: true
                    }, { root: true })
                }
            })
    },

    editUserFee: async({ dispatch, commit }, data) => {
        const url = {
            fee: 'account/change-fee',
            telephonyFee: 'account/change-fee',
            leaderFee: 'account/change-leader-fee',
            leaderTelephonyFee: 'account/change-leader-fee'
        }[data.type]

        return request({
            method: 'put',
            url, data
        })
            .then(res => res.status)
            .catch(error => {
                const message = error.response && error.response.data && error.response.data.message

                if (message) {
                    dispatch('addMessage', {
                        type: 'error',
                        message,
                        locale: true
                    }, { root: true })
                }
            })
    },

    getNumberOfReferrals: async({ dispatch, commit }) => {
        await request({ method: 'get', url: 'referrals/sum' })
            .then(res => {
                if (res.data) {
                    commit('SET_COUNT_BUSINESSES', res.data.businesses)
                    commit('SET_COUNT_CLIENTS', res.data.clients)
                    commit('SET_COUNT_UNCONFIRMED_BUSINESSES', res.data.unconfirmedBusinesses)
                }
            })
    },

    updateAccountAmount: async({ dispatch }, { accountId, amount, field }) => {
        return await request({
            method: 'put',
            url: `/account/${accountId}/amount`,
            data: { amount, field }
        }).then(res => {
            return res.status
        }).catch(err => {
            if (err.response && err.response.data && err.response.data.message && ![401, 403].includes(err.response.status)) {
                dispatch('addMessage', {
                    type: 'error',
                    message: app.$vuetify.t(`$vuetify.messages.error.accountAmount.${err.response.data.message}`),
                    locale: false
                }, { root: true })
            }
        })
    }
}
